import React from 'react';

/**
 * Greeting — top-of-page hello + sub copy that adapts to scenario.
 * scenario: 'active' | 'calm' | 'firstrun'
 */
function greetingFor(scenario, name) {
  const who = name || 'there';
  if (scenario === 'firstrun') return { head: <>Welcome to Dathent, <span className="grad-text">{who}</span>.</>, sub: "Three quick steps and your first batch will be live. Pick where you want to begin." };
  if (scenario === 'calm') return { head: <>Good day, <span className="grad-text">{who}</span>.</>, sub: "Nothing on fire. Here's how the week is shaping up." };
  return { head: <>Hello, <span className="grad-text">{who}</span>.</>, sub: "Your batch is generating. Here's where it stands." };
}

export default function Greeting({ scenario = 'calm', name }) {
  const { head, sub } = greetingFor(scenario, name);
  return (
    <div className="dash-greet">
      <h1>{head}</h1>
      <p>{sub}</p>
    </div>
  );
}
